import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'

// Selector múltiple. Sigue el mismo contrato que `InputSelect` (label / name /
// value / values / onChange) pero con `value` como array de `id`, que es como
// llegan las categorías y los departamentos desde el backend.
export const InputSelectMultiple = ({ label, value = [], values = [], onChange, name, disabled }: any) => {

    // El backend devuelve ids numéricos, así que se comparan como number para que
    // el `checked` del checkbox coincida aunque el value venga como string.
    const seleccionados: number[] = Array.isArray(value)
        ? value.map((id: any) => parseInt(id, 10)).filter((id: any) => !isNaN(id))
        : []

    // Las listas del backend traen la columna `nombre`; los catálogos que se
    // definen en el front usan `name` (ver `InputSelect`), así que se aceptan
    // ambas para no obligar a renombrar unos u otros.
    const textoDe = (item: any) => item?.nombre || item?.name || ''

    const nombreDe = (id: any) => textoDe(values?.find((item: any) => item.id === id))

    return (
        <FormControl fullWidth variant="standard">
            <InputLabel id={`input-select-multiple-${name}-label`}>{label}</InputLabel>
            <Select
                labelId={`input-select-multiple-${name}-label`}
                id={`input-select-multiple-${name}`}
                multiple
                disabled={disabled}
                value={seleccionados}
                name={name}
                onChange={onChange}
                label={label}
                renderValue={(selected: any) => (
                    <Typography variant='body2' className='my-0'>
                        {(selected || []).map((id: any) => nombreDe(id)).filter(Boolean).join(', ') || '-'}
                    </Typography>
                )}
            >
                {
                    (values || []).map((item: any) => (
                        <MenuItem key={item.id} value={item.id}>
                            <Checkbox size="small" checked={seleccionados.includes(item.id)} />
                            <ListItemText primary={textoDe(item)} />
                        </MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    )
}